class SupernovaCarousel extends window.BAO.CustomElement {
  constructor () {
    super()

    this.initialiseCarousel()
  }

  initialiseCarousel () {
    // eslint-disable-next-line new-cap
    const slider = new window.KeenSlider685(this.els.slides.element, {
      loop: false,
      mode: 'snap',
      rtl: false,
      slides: {
        perView: 1.05,
        spacing: 15
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            perView: 'auto',
            spacing: 60
          }
        }
      }
    })
  }
}

if (!customElements.get('supernova-carousel')) {
  customElements.define('supernova-carousel', SupernovaCarousel)
}
